import React from "react";
import Calendario from "../atoms/Calendario";

const FormRegister = () => {
  return (
    <div className="card">
      <div className="card-body px-4 px-md-5">
        <div className="row">
          <div className="col-md-12">
            <form>
              <div className="row">
                <div className="col-md-12 px-2">
                  <div className="form-group">
                    <label className="form-label">Nombre(s)*</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="col-sm-6 px-2">
                  <div className="form-group">
                    <label className="form-label">Apellido Materno*</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="col-sm-6 px-2">
                  <div className="form-group">
                    <label className="form-label">Apellido Materno*</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="col-sm-6 px-2">
                  <div className="form-group">
                    <label className="form-label">Estado Civil</label>
                    <select className="form-control">
                      <option></option>
                    </select>
                  </div>
                </div>
                <div className="col-sm-6 px-2">
                  <div className="form-group">
                    <label className="form-label d-block">Nacionalidad</label>
                    <div className="custom-radio d-inline-block">
                      <input type="radio" id="Mexicana" name="Otro" checked />
                      <label for="Mexicana">Mexicana</label>
                    </div>
                    <div className="custom-radio d-inline-block ml-4">
                      <input type="radio" id="Otro" name="Otro" />
                      <label for="Otro">Otro</label>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 px-2">
                  <div className="form-group">
                    <label className="form-label">Fecha de Nacimiento</label>
                    <Calendario />
                  </div>
                </div>
                <div className="col-sm-6 px-2">
                  <div className="form-group">
                    <label className="form-label d-block">Género</label>
                    <div className="custom-radio d-inline-block">
                      <input type="radio" id="fem" name="gender" />
                      <label for="fem">Femenino</label>
                    </div>
                    <div className="custom-radio d-inline-block ml-4">
                      <input type="radio" id="masc" name="gender" checked />
                      <label for="masc">Masculino</label>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 px-2">
                  <div className="form-group">
                    <label className="form-label">R.F.C.*</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="col-sm-6 px-2">
                  <div className="form-group">
                    <label className="form-label">HOMOCLAVE*</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="col-sm-6 px-2">
                  <div className="form-group">
                    <label className="form-label">Correo</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="col-sm-6 px-2">
                  <div className="form-group">
                    <label className="form-label">Contraseña</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="col-md-12 px-2">
                  <div className="form-group custom-checkbox mb-0">
                    <input type="checkbox" id="acepto" />
                    <label for="acepto">
                      He leído y acepto los términos y condiciones de
                      bajatuseguro.
                    </label>
                  </div>
                  <div className="form-group custom-checkbox">
                    <input type="checkbox" id="Privacidad" />
                    <label for="Privacidad">
                      He leído y estoy de acuerdo con el{" "}
                      <a href="#">Aviso de Privacidad</a>.
                    </label>
                  </div>
                </div>
                <div className="col-md-12 text-center">
                  <button
                    type="button"
                    name="next"
                    className="btn btn-warning next px-5 mt-2 mb-3"
                  >
                    Registrarme
                  </button>
                  <p className="mb-0">
                    <a href="#">Ya tengo una cuenta</a>
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormRegister;
